<section class="mt-8" aria-labelledby="billing-components-heading">
  <!-- Header -->
  <div class="mb-2 flex items-center gap-1.5">
    <mat-icon aria-hidden="true" class="text-base!">receipt_long</mat-icon>
    <h3
      id="billing-components-heading"
      class="text-sm font-medium tracking-widest uppercase"
    >
      Billing components
      @if (components?.length > 0) {
        ({{ components.length }})
      }
    </h3>
  </div>

  <!-- List -->
  <div class="border-gray-150 overflow-hidden rounded-sm border bg-white">
    <table class="w-full border-collapse">
      <caption class="sr-only">
        Monthly billing components and total for this service
      </caption>
      <thead>
        <tr class="sr-only">
          <th scope="col">Component</th>
          <th scope="col">Monthly cost</th>
        </tr>
      </thead>
      <tbody>
        @for (component of components; track component.Id) {
          <tr class="even:bg-gray-50/50">
            <td class="border-b border-gray-100 px-3 py-2.5 text-sm sm:px-4">
              {{ component.Display_Name__c }}
            </td>
            <td
              class="border-b border-gray-100 px-3 py-2.5 text-right text-sm font-medium whitespace-nowrap sm:px-4"
              [ngClass]="component.MRR__c === 0 ? 'text-brand-muted' : ''"
            >
              {{ component.MRR__c | currency }}
            </td>
          </tr>
        }
      </tbody>
      <tfoot>
        <tr class="bg-gray-50">
          <th
            scope="row"
            class="px-3 py-3 text-left text-sm font-semibold uppercase sm:px-4"
          >
            Total
          </th>
          <td
            class="px-3 py-3 text-right text-base font-semibold whitespace-nowrap sm:px-4 sm:text-lg"
          >
            <span class="sr-only">Total monthly charge:</span>
            {{ monthlyTotal ? (monthlyTotal | currency) : '$0.00' }}
            <span
              class="text-brand-muted text-sm font-normal"
              aria-hidden="true"
              >/mo</span
            >
            <span class="sr-only">per month</span>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</section>

